(() => {
  if (customElements.get('fva-honey-shop')) return;
  customElements.define('fva-honey-shop', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.addEventListener('change', event => {
        const input = event.target.closest('[data-honey-variant]');
        if (!input || !input.checked) return;
        const price = this.querySelector('[data-honey-price]');
        if (price) price.textContent = input.dataset.money;
        const jar = this.querySelector('[data-honey-jar]');
        if (jar && input.dataset.photo) {
          jar.src = input.dataset.photo;
          jar.alt = input.dataset.alt;
        }
        const quantity = this.querySelector('[name="quantity"]');
        if (quantity) {
          const min = Math.max(1, Number(input.dataset.min) || 1);
          const step = Math.max(1, Number(input.dataset.step) || 1);
          const max = Number(input.dataset.max) || Infinity;
          quantity.min = String(min);
          quantity.step = String(step);
          if (Number.isFinite(max)) quantity.max = String(max);
          else quantity.removeAttribute('max');
          const value = Math.max(min, Number(quantity.value) || min);
          const aligned = min + Math.floor((value - min) / step) * step;
          quantity.value = String(Math.min(aligned, max));
        }
        if (this.dataset.productPage === 'true') {
          const url = new URL(location.href);
          url.searchParams.set('variant', input.value);
          history.replaceState({}, '', url);
        }
      });
    }
  });
})();
